import React from "react";
import CounterApp from "./Counter";
import img from "../assets/images/airdrop.png";

const CounterBox = ({ tokenValue }) => {
  return (
    <div className="counter-box">
      <img src={img} alt="airdrop" className="airdrop-img" />
      <CounterApp tokenValue={tokenValue} />
    </div>
  );
};

export default CounterBox;
